/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { InMemoryCache } from '@apollo/client/cache';
import { createHttpLink } from 'apollo-link-http';
import { ApolloClient } from '@apollo/client/core';
import { loadStripe } from '@stripe/stripe-js';
import envConfig from '@nile/home/src/Config/env';
import { AppProvider } from '@shopify/polaris';
import { Button, Card, Heading } from '@superops/ui-design-system';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  UPDATE_INVOICE_VIEW_STATUS,
  GET_CLIENT_INVOICE,
  GET_INTEGRATIONS_BY_IDS,
  INIT_INVOICE_PAYMENT,
  CONFIRM_INVOICE_PAYMENT
} from '@nile/graphql';
import {
  useElements,
  useStripe,
  CardElement,
  PaymentElement
} from '@stripe/react-stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { GET_PRIMARY_COMPANY } from '@nile/banyan/src/Graphql/Mutations/msp';
import { useQuery, useMutation } from '@apollo/client';
import styled from 'styled-components';
import {
  getHeaderValue,
  getCookieValue,
  getCustomSubDomain,
  toast,
  getTranslatedText,
  Loader,
  BrandingLogo,
  CurrencyText,
  DateTimeFormatter
} from '@nile/components';
import { errorLink } from '@nile/graphql/src/QueryManager/ErrorMiddleware';
import InvoiceDetails from '@nile/client_management/src/Pages/Invoice/InvoiceDetails';
import { SVGIcon } from '@superops/super-icons';
import { COMMON_CONSTANTS } from '@nile/components';

const InvoiceDetailsWrapper = styled.div.attrs({
  className: 'invoice-details'
})`
  width: 50%;
  height: 100%;
  padding: 40px 40px 40px 60px;
  box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.1);

  .branding-logo {
    margin-bottom: 30px;

    .msp-branding {
      img {
        margin-bottom: 30px;
      }

      span {
        font-size: 24px;
        font-weight: 700;
      }
    }
  }
`;

const StripeCheckoutContainer = styled.div.attrs({
  className: 'stripe-checkout-form'
})`
  width: 50%;
  .checkout-holder {
    margin: 0 auto;
    width: 50%;
  }

  .Superops-Card {
    border-radius: 10px;
    background: #fff;
    box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    gap: 20px;
    padding: 30px 40px;
    flex-direction: column;

    & *:last-child {
      font-size: 14px;
      font-weight: 400;
    }
  }

  .success {
    padding: 40px;
  }

  div.payment-details {
    margin-bottom: 30px;
  }
`;

const InvoiceDataContainer = styled.div`
  padding: 20px 6px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;

  .total-amount {
    font-size: 24px;
    font-weight: 600;
    margin-left: auto;
  }

  .Superops-Heading--sizePrimary {
    line-height: unset;
  }

  .Superops-Heading {
    padding-bottom: 20px;
  }

  .cell {
    font-size: 10px;
    font-weight: 400;
    line-height: 20px;
    span {
      // DateTimeFormatter
      font-size: 10px;
      font-weight: 500;
      line-height: 20px;
    }
  }
`;

const cache = new InMemoryCache({
  addTypename: false
});

function PayInvoice(props) {
  const { intl } = props;
  const params = new URLSearchParams(props.location.search);
  const clientId = params.get('clientId');
  const invoiceId = params.get('invoiceId');
  const token = params.get('token');
  const [stripeAccountId, setStripeAccountId] = useState(null);
  const AccountClient = new ApolloClient({
    cache,
    link: errorLink.concat(
      createHttpLink({
        uri: localStorage?.getItem('apiDomain') + envConfig.accountsGateway,
        credentials: 'include',
        headers: {
          ...getHeaderValue(),
          authorization: `Bearer nl-${token}`
        }
      })
    ),
    connectToDevTools: true
  });
  const getIntegration = async (accountClient) => {
    const authClient = accountClient || AccountClient;
    const response = await authClient
      .query({
        query: GET_INTEGRATIONS_BY_IDS,
        variables: {
          integrationIds: ['STRIPE']
        },
        fetchPolicy: 'network-only'
      })
      .then((res) => {
        if (res?.data?.getIntegrationsByIds?.length) {
          if (
            res.data.getIntegrationsByIds.find(
              (integration) => integration.activated
            )
          ) {
            setStripeAccountId(
              res.data.getIntegrationsByIds[0]?.data.accountId
            );
          }
          return res.data?.getIntegrationsByIds[0];
        }
      })
      .catch((err) => {})
      .finally(() => {});
    return response;
  };
  useEffect(() => {
    getIntegration(AccountClient);
  }, []);
  if (!stripeAccountId) {
    return <Loader />;
  }
  return (
    <AppProvider>
      <Invoice
        clientId={clientId}
        invoiceId={invoiceId}
        token={token}
        AccountClient={AccountClient}
        intl={intl}
        stripeAccountId={stripeAccountId}
      />
    </AppProvider>
  );
}
function Invoice(props) {
  const {
    clientId,
    invoiceId,
    token,
    AccountClient,
    intl,
    stripeAccountId
  } = props;
  const [pdfDownloading, setPDFDownload] = useState(false);
  const [data, setData] = useState(null);
  const [ispdfDownloading, setPDFDownloadLoading] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);
  const [invoicePaymentOptions, setInvoicePaymentOptions] = useState(null);
  const [paymentIntentId, setPaymentIntentId] = useState(null);
  const {
    loading: companyLoading,
    error: companyError,
    data: mspcompany
  } = useQuery(GET_PRIMARY_COMPANY, {
    client: AccountClient,
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE
  });
  const [initInvoicePayment] = useMutation(INIT_INVOICE_PAYMENT, {
    client: AccountClient
  });
  function callStripe(stripeAccount) {
    // const stripePromise = loadStripe(envConfig.stripePublicKey);
    return loadStripe(envConfig.stripePublicKey, {
      stripeAccount
    });
  }
  const fetchViewData = async () => {
    const response = await AccountClient.query({
      query: GET_CLIENT_INVOICE,
      variables: {
        invoiceId: invoiceId,
        isIntegratedInvoiceId: true,
        isTaxSplitEnabled: true
      },
      fetchPolicy: 'network-only'
    });
    setData(response?.data?.getInvoice);
  };

  useEffect(() => {
    if (invoiceId) {
      fetchViewData();
      initInvoicePayment({
        variables: {
          invoiceId: invoiceId
        }
      }).then((res) => {
        if (res?.data?.initInvoicePayment) {
          setClientSecret(res.data.initInvoicePayment.client_secret);
          setPaymentIntentId(res.data.initInvoicePayment.id);
          setInvoicePaymentOptions(res.data.initInvoicePayment);
        }
      });
    }
  }, []);
  if (companyLoading || !clientSecret || !invoicePaymentOptions)
    return <Loader />;
  const company = mspcompany?.getPrimaryCompany;
  const options = {
    clientSecret: invoicePaymentOptions.client_secret
  };
  return (
    <div className="flex center jcenter overflow-auto full-height white-bg">
      <Elements stripe={callStripe(stripeAccountId)} options={options}>
        <CheckoutForm
          clientSecret={invoicePaymentOptions.client_secret}
          data={data}
          company={company}
          AccountClient={AccountClient}
        />
      </Elements>
    </div>
  );
}

const CheckoutForm = (props) => {
  const { data, company, AccountClient } = props;
  const [errorMessage, setErrorMessage] = useState(null);
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);

  const [confirmInvoicePayment] = useMutation(CONFIRM_INVOICE_PAYMENT, {
    client: AccountClient
  });

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    setLoading(true);
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    try {
      await elements.submit();
      const res = await stripe.confirmPayment({
        // `Elements` instance that was used to create the Payment Element
        elements,
        clientSecret: props.clientSecret,
        redirect: 'if_required'
      });

      if (res?.paymentIntent?.id) {
        await confirmInvoicePayment({
          variables: {
            paymentIntentId: res?.paymentIntent?.id
          }
        });
      }

      const { error } = res;
      if (error) {
        // This point will only be reached if there is an immediate error when
        // confirming the payment. Show error to your customer (for example, payment
        // details incomplete)
        setErrorMessage(error.message);
      } else {
        // Your customer will be redirected to your `return_url`. For some payment
        // methods like iDEAL, your customer will be redirected to an intermediate
        // site first to authorize the payment, then redirected to the `return_url`.
        setPaymentSuccess(true);
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="flex center jcenter full-width full-height">
      <InvoiceDetailsWrapper>
        <BrandingLogo alignVertical />
        <InvoiceDataContainer>
          <div>
            <Heading element="h1" weight="bold">
              {data.title || `Invoice #${data.displayId}`}
            </Heading>

            <div>
              <div className="cell">
                <FormattedMessage id="Invoice Id" />
                {' : '}
                <span>{data.displayId}</span>
              </div>
              <div className="cell">
                <FormattedMessage id="invoice.details.invoiceDate" />
                {' : '}
                <DateTimeFormatter
                  type="date"
                  // date={dayjs().format('YYYY-MM-DD')}
                  date={data.invoiceDate}
                />
              </div>
              <div className="cell">
                <FormattedMessage id="invoice.details.dueDate" />
                {' : '}
                {data.dueDate ? (
                  <DateTimeFormatter
                    type="date"
                    // date={dayjs().format('YYYY-MM-DD')}
                    date={data.dueDate}
                  />
                ) : (
                  'NA'
                )}
              </div>
            </div>
          </div>
          <div className="total-amount">
            <CurrencyText value={data.amountDue} />
          </div>
        </InvoiceDataContainer>
      </InvoiceDetailsWrapper>
      <StripeCheckoutContainer>
        {!paymentSuccess ? (
          <div className="checkout-holder">
            <div className="payment-details">
              <Heading
                className="payment-details-header"
                element="h1"
                weight="bold"
              >
                <FormattedMessage id="stripe.invoice.paymentDetails" />
              </Heading>
            </div>
            <form onSubmit={handleSubmit}>
              <PaymentElement />
              <div className="mt-10">
                <Button primary loading={loading} onClick={handleSubmit}>
                  <FormattedMessage id="invoice.details.payNow" />
                </Button>
              </div>
              {errorMessage && <div className="mt-10">{errorMessage}</div>}
            </form>
          </div>
        ) : (
          <div className="success">
            <Card>
              <SVGIcon name="CircleTickOutlineMinor" color="#48ac3e" />

              <Heading element="h1" weight="bold">
                <FormattedMessage id="invoice.payment.paymentSuccessful" />
              </Heading>

              <div>
                <FormattedMessage id="invoice.payment.paymentSuccessDescription" />
              </div>
            </Card>
          </div>
        )}
      </StripeCheckoutContainer>
    </div>
  );
};

export default injectIntl(withRouter(PayInvoice));
